var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "giftList" },
    [
      _c(
        "el-form",
        {
          ref: "tableForm",
          attrs: { model: { tableData: _vm.value }, rules: _vm.formRules },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.value, size: "mini" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "giftsCode",
                  label: "赠品编码",
                  width: "200",
                  "render-header": _vm.renderHeade,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row, $index }) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tableData." + $index + ".giftsCode",
                              rules: _vm.formRules.giftsCode,
                            },
                          },
                          [
                            _c("el-autocomplete", {
                              staticStyle: { width: "175px" },
                              attrs: {
                                "fetch-suggestions": _vm.querySearch,
                                placeholder: "请输入商品编码",
                                "trigger-on-focus": false,
                                maxlength: 40,
                                "show-word-limit": "",
                              },
                              on: {
                                select: (value) =>
                                  _vm.handleSelectGiftsCode(value, row),
                              },
                              model: {
                                value: row.giftsCode,
                                callback: function ($$v) {
                                  _vm.$set(row, "giftsCode", $$v)
                                },
                                expression: "row.giftsCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "giftsName",
                  label: "赠品名称",
                  "min-width": "180",
                  "render-header": _vm.renderHeade,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row, $index }) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tableData." + $index + ".giftsName",
                              rules: _vm.formRules.giftsName,
                            },
                          },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请输入赠品名称",
                                maxlength: "30",
                                "show-word-limit": "",
                              },
                              model: {
                                value: row.giftsName,
                                callback: function ($$v) {
                                  _vm.$set(row, "giftsName", $$v)
                                },
                                expression: "row.giftsName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "giftsNum",
                  label: "赠品数量",
                  width: "120",
                  "render-header": _vm.renderHeade,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row, $index }) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tableData." + $index + ".giftsNum",
                              rules: _vm.formRules.giftsNum,
                            },
                          },
                          [
                            _c("el-input-number", {
                              attrs: {
                                placeholder: "请输入赠品数量",
                                min: 1,
                                max: 8,
                                "step-strictly": true,
                                controls: false,
                              },
                              model: {
                                value: row.giftsNum,
                                callback: function ($$v) {
                                  _vm.$set(row, "giftsNum", $$v)
                                },
                                expression: "row.giftsNum",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "giftsImgList",
                  label: "赠品图片(最多上传7张图片)",
                  width: "400",
                  "render-header": _vm.renderHeade,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row, $index }) {
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop: "tableData." + $index + ".giftsImgList",
                              rules: _vm.formRules.giftsImgList,
                            },
                          },
                          [
                            _c("ImageUpload", {
                              attrs: {
                                limit: 7,
                                tips: [
                                  "最多上传7张图片，图片不能大于5M，格式为jpg,png,jpeg",
                                ],
                              },
                              on: {
                                change: (value) =>
                                  _vm.getGiftsListChange(row, value),
                              },
                              model: {
                                value: row.giftsImgList,
                                callback: function ($$v) {
                                  _vm.$set(row, "giftsImgList", $$v)
                                },
                                expression: "row.giftsImgList",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "action", label: "操作", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ $index }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete($index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-button",
        {
          staticClass: "addBtn",
          attrs: { size: "mini", plain: "", type: "primary" },
          on: { click: _vm.handleAdd },
        },
        [_vm._v("新增赠品")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }